import { useMutation } from '@tanstack/react-query';
import { api } from '../client';
import type { Report } from '../../generated/fresh-guard-api';

export function useReportingCsvExport() {
  return useMutation({
    mutationFn: async (input: { report: Report }) => {
      return await api.reportingApi.apiReportingcsvExportReportGet(input.report, {
        responseType: 'text',
      });
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
